<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line class="pt-0">
        <v-list-item-title class="headline">
          {{ $t('administration.title') }}</v-list-item-title
        >
        <v-list-item-subtitle>{{
          $t('administration.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-list dense>
        <v-list-group
          v-for="entry in entries"
          :key="entry.name"
          :prepend-icon="entry.icon"
          no-action
          v-model="entry.active"
        >
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title>{{
                $t('administration.' + entry.name + '.title')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-for="menu in entry.menus"
            :key="menu.name"
            :to="{
              name: menu.link
                ? menu.link
                : 'administration/' + entry.name + '/' + menu.name,
            }"
          >
            <v-list-item-icon><v-icon v-text="menu.icon"/></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t(
                  menu.i18n
                    ? menu.i18n
                    : 'administration.' +
                        entry.name +
                        '.' +
                        menu.name +
                        '.title',
                )
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      activeTab: '',
      entries: [
        {
          name: 'exportSynchronisation',
          icon: 'mdi-export',
          menus: [
            {
              name: 'export',
              icon: 'mdi-export',
            },
            {
              name: 'synchronisation',
              icon: 'mdi-autorenew',
            },
          ],
        },
        {
          name: 'tablesReference',
          icon: 'mdi-table-edit',
          menus: [
            {
              name: 'pays',
              icon: 'mdi-earth',
            },
            {
              name: 'region',
              icon: 'mdi-hexagon-multiple',
            },
            {
              name: 'departement',
              icon: 'mdi-bank',
            },
            {
              name: 'ville',
              icon: 'mdi-city',
            },
            {
              name: 'typeAccesAgil',
              icon: 'mdi-shield-home',
            },
            {
              name: 'privilegeAgil',
              icon: 'mdi-shield-lock',
            },
            {
              name: 'typeAcces',
              icon: 'mdi-shield-link-variant',
            },
            {
              name: 'domaineActivite',
              icon: 'mdi-domain',
            },
            {
              name: 'secteurActivite',
              icon: 'mdi-domain',
            },
            {
              name: 'civilite',
              icon: 'mdi-human-male-female',
            },
            {
              name: 'fonctionContact',
              icon: 'mdi-account-tie',
            },
            {
              name: 'typeContact',
              icon: 'mdi-account-box',
            },
            {
              name: 'typeDivision',
              icon: 'mdi-office-building-marker',
            },
            {
              name: 'typeInstance',
              icon: 'mdi-account-group',
            },
            {
              name: 'typeLait',
              icon: 'mdi-cow',
            },
            {
              name: 'typeParticipant',
              icon: 'mdi-account-circle',
            },
            {
              name: 'typePersonneMorale',
              icon: 'mdi-domain',
            },
            {
              name: 'demandeType',
              icon: 'mdi-file-document',
            },
            {
              name: 'demandeStatus',
              icon: 'mdi-list-status',
            },
          ],
        },
        {
          name: 'personneMorale',
          icon: 'mdi-domain',
          menus: [
            {
              name: 'personnesMorales',
              icon: 'mdi-folder-multiple',
              i18n: 'administration.personneMorale.title',
            },
            {
              name: 'contextes',
              icon: 'mdi-layers-triple',
            },
            {
              name: 'cotisable',
              icon: 'mdi-wallet-membership',
            },
          ],
        },
        {
          name: 'profils',
          icon: 'mdi-account-multiple',
          menus: [
            {
              name: 'typeAccesAgil',
              icon: 'mdi-shield-home',
              link: 'administration/tablesReference/typeAccesAgil',
              i18n: 'administration.tablesReference.typeAccesAgil.title',
            },
            {
              name: 'privilegeAgil',
              icon: 'mdi-shield-lock',
              link: 'administration/tablesReference/privilegeAgil',
              i18n: 'administration.tablesReference.privilegeAgil.title',
            },
            {
              name: 'autorisationAgil',
              icon: 'mdi-shield-check',
            },
          ],
        },
        {
          name: 'rgpd',
          icon: 'mdi-shield-lock',
          menus: [
            {
              name: 'contacts',
              icon: 'mdi-account-clock',
            },
            {
              name: 'alerteValidite',
              icon: 'mdi-account-alert',
            },
            {
              name: 'donneesRGPD',
              icon: 'mdi-shield-account',
            },
          ],
        },
        {
          name: 'traitements',
          icon: 'mdi-run-fast',
        },
        {
          name: 'mails',
          icon: 'mdi-email',
          menus: [
            {
              name: 'liste',
              icon: 'mdi-email',
              link: 'administration/mails/liste',
            },
            {
              name: 'historique',
              icon: 'mdi-email',
              link: 'administration/mails/historique',
            },
          ],
        },
        {
          name: 'corbeille',
          icon: 'mdi-trash-can',
          menus: [
            {
              name: 'corbeille',
              icon: 'mdi-trash-can',
            },
          ],
        },
      ],
    };
  },
  created() {
    var tabName = this.$route.params.tab;
    if (tabName) {
      this.entries.forEach(function(item) {
        if (item.name === tabName) {
          item.active = true;
        }
      });
    }
  },
  methods: {},
};
</script>

<style scoped></style>
